import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../geometry.js";
import e from "../../request.js";
import { urlToObject as t } from "../../core/urlUtils.js";
import { getJsonType as r, fromJSON as s } from "../../geometry/support/jsonUtils.js";

function o(_x, _x2, _x3, _x4) {
  return _o.apply(this, arguments);
}

function _o() {
  _o = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(o, i, n, m) {
    var p, a, u, c, _c$data, f, _c$data$geometries, g;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            p = "string" == typeof o ? t(o) : o;
            a = i[0].spatialReference;
            u = _objectSpread(_objectSpread({}, m), {}, {
              query: _objectSpread(_objectSpread({}, p.query), {}, {
                f: "json",
                sr: JSON.stringify(a),
                target: JSON.stringify({
                  geometryType: r(i[0]),
                  geometries: i
                }),
                cutter: JSON.stringify(n)
              })
            });
            _context.next = 5;
            return e(p.path + "/cut", u);

          case 5:
            c = _context.sent;
            _c$data = c.data;
            f = _c$data.cutIndexes;
            _c$data$geometries = _c$data.geometries;
            g = _c$data$geometries === void 0 ? [] : _c$data$geometries;
            return _context.abrupt("return", {
              cutIndexes: f,
              geometries: g.map(function (e) {
                var t = s(e);
                return t.spatialReference = a, t;
              })
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _o.apply(this, arguments);
}

export { o as cut };